import { Injectable } from "@angular/core";
import { TimerService } from "../services/timer.service";
import { Events } from "ionic-angular";

@Injectable()
export class FarmtekReader {
    barrelSplitTimeRun: BarrelSplitTimeRun;
    scoreboardTimer: boolean;
    startTime: number;

    eyeTwoNumber: string = "2";
    eyeThreeNumber: string = "3";
    eyeFourNumber: string = "4";

    timeDisplay: any;
    lastTimeReceived: any;

    rodeoId: number;
    accountId: number;

    nextGenOnlineClockRunning: boolean;
    clockStopped: number;

    constructor(private timerService: TimerService, private events: Events) { }

    handleScoreboardData(data: string) {
        if ((data != null && data.length != 0) && data[0] == 'B' || data[0] == 'S' || data[0] == 'F' || data[0] == 'R') {
            if (data[0] != 'R') {
                if (data[0] == 'S') {
                    this.startSplitRun();
                }
                var neweyeNumber = data.substring(1, 2);
                var timeBreak = +data.substring(2);

                this.barrelSplitTimeRun.addNewEyeBreak(new EyeBreak(neweyeNumber, timeBreak), this.eyeTwoNumber, this.eyeThreeNumber, this.eyeFourNumber);

                if (data[0] == 'F') {
                    this.barrelSplitTimeRun.done = true;
                    this.barrelSplitTimeRun.totalTime = Math.round((1000 * (this.barrelSplitTimeRun.eyeBreaks[this.barrelSplitTimeRun.eyeBreaks.length - 1].timeBreak - this.barrelSplitTimeRun.eyeBreaks[0].timeBreak) / 8000)) / 1000;
                    this.timeDisplay = this.barrelSplitTimeRun.totalTime;

                    this.scoreboardTimer = false;

                    this.lastTimeReceived = this.barrelSplitTimeRun.totalTime;
                    this.showTime(this.barrelSplitTimeRun.totalTime);
                    this.timeDisplay = this.barrelSplitTimeRun.totalTime;
                    return;
                }
            }
            else {
                return;
            }
        }


        this.showTime(+(data.trim()));
    }

    showTime(time: number) {
        if (this.lastTimeReceived != time) {
            this.startClock();
        }
        else
            this.stopClock(time + "");

        this.lastTimeReceived = time;
    }

    getTime() {
        return this.lastTimeReceived;
    }

    getBarrelSplitRun() {
        return this.barrelSplitTimeRun;
    }

    startSplitRun() {
        this.barrelSplitTimeRun = new BarrelSplitTimeRun();

        this.startTime = new Date().getTime();
        this.scoreboardTimer = true;
        this.startTimer();
    }

    startTimer() {
        if (!this.scoreboardTimer)
            return;

        this.lastTimeReceived = Math.round(1000 * ((new Date().getTime() - this.startTime) / 1000)) / 1000;
        this.events.publish("TimeUpdated", this.lastTimeReceived);

        setTimeout(() => this.startTimer(), 7);
    }

    stopSplitRun() {
        this.barrelSplitTimeRun.done = true;
        this.barrelSplitTimeRun.totalTime = Math.round(1000 * ((new Date().getTime() - this.startTime) / 10000000)) / 1000;
        this.scoreboardTimer = false;

        this.lastTimeReceived = this.barrelSplitTimeRun.totalTime;
    }

    startClock() {
        if (this.nextGenOnlineClockRunning)
            return;

        this.nextGenOnlineClockRunning = true;

        this.timerService.startRunningClock(this.rodeoId, this.accountId)
            .then(() => {
                this.nextGenOnlineClockRunning = true;
            }, error => {
                this.nextGenOnlineClockRunning = false;
            });
    }

    stopClock(time: string) {
        if (!this.rodeoId || !this.accountId || !this.nextGenOnlineClockRunning)
            return;

        this.nextGenOnlineClockRunning = false;

        this.timerService.stopRunningClock(time, this.rodeoId, this.accountId)
            .then(() => {
                this.nextGenOnlineClockRunning = false;
            }, error => {
                this.nextGenOnlineClockRunning = true;
            });
    }
}

export class EyeBreak {
    eyeNumber: string;
    timeBreak: number;

    constructor(eyeNumber, timeBreak) {
        this.eyeNumber = eyeNumber;
        this.timeBreak = timeBreak;
    }
}

export class SplitRun {
    eyeNumber: string;
    time: string;
}

export class BarrelSplitTimeRun {
    updated: number;
    eyeBreaks: EyeBreak[] = [];
    splitRuns: SplitRun[] = [];

    straightOneSplit: string;
    aroundBarrelOneSplit: string;
    straightTwoSplit: string;
    aroundBarrelTwoSplit: string;
    straightThreeSplit: string;
    aroundBarrelThreeSplit: string;
    straightFourSplit: string;

    totalTime: number;
    goingLeft: boolean;
    done: boolean;

    getSummary() {
        var summary = "";

        for (var i = 0; i < this.eyeBreaks.length - 1; i++) {
            var symbol = this.eyeBreaks[i].eyeNumber == this.eyeBreaks[i + 1].eyeNumber ? " Ω " : " -> ";
            summary += "\n#" + this.eyeBreaks[i].eyeNumber + symbol + "#" + this.eyeBreaks[i + 1].eyeNumber + " : " + this.formatTime((this.eyeBreaks[i + 1].timeBreak - this.eyeBreaks[i].timeBreak) / 8000);
        }

        summary += "\n\nTotalTime : " + this.totalTime;

        return summary;
    }

    formatTime(time: number): string {
        return (Math.round(1000 * time) / 1000) + '';
    }

    addNewEyeBreak(eyeBreak: EyeBreak, eyeTwoNumber: string, eyeThreeNumber: string, eyeFourNumber: string) {
        var previousEyebreak = this.eyeBreaks.length > 0 ? this.eyeBreaks[this.eyeBreaks.length - 1] : null;
        this.eyeBreaks.push(eyeBreak);
        this.updated = new Date().getTime();

        if (previousEyebreak != null)
            console.log("Received New Eye Break Eye (" + eyeBreak.eyeNumber + ") Time Stamp: " + eyeBreak.timeBreak + ", time since last: " + this.formatTime(eyeBreak.timeBreak - previousEyebreak.timeBreak / 8000));

        if (this.eyeBreaks.length > 0) {
            if (this.straightOneSplit == null) {
                if (this.eyeBreaks.some(x => x.eyeNumber == "1") && (eyeBreak.eyeNumber == eyeTwoNumber || eyeBreak.eyeNumber == eyeThreeNumber)) {
                    this.straightOneSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - this.eyeBreaks.filter(x => x.eyeNumber == "1")[0].timeBreak) / 8000);

                    this.goingLeft = eyeBreak.eyeNumber == eyeThreeNumber;
                }
            }
            else {
                var eyeTwoBreaks = this.eyeBreaks.filter(x => x.eyeNumber == eyeTwoNumber);
                var eyeThreeBreaks = this.eyeBreaks.filter(x => x.eyeNumber == eyeThreeNumber);
                var eyeFourBreaks = this.eyeBreaks.filter(x => x.eyeNumber == eyeFourNumber);

                if (this.goingLeft) {
                    if (eyeBreak.eyeNumber == eyeThreeNumber && this.aroundBarrelOneSplit == null) {
                        this.aroundBarrelOneSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - this.eyeBreaks.filter(x => x.eyeNumber == eyeThreeNumber)[0].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == eyeTwoNumber && this.straightTwoSplit == null) {
                        var eyeThreeBreaks = this.eyeBreaks.filter(x => x.eyeNumber == eyeThreeNumber);

                        if (eyeThreeBreaks.length > 1)
                            this.straightTwoSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeThreeBreaks[1].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == eyeTwoNumber && this.aroundBarrelTwoSplit == null) {
                        if (eyeTwoBreaks.length > 1)
                            this.aroundBarrelTwoSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeTwoBreaks[0].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == eyeFourNumber && this.straightThreeSplit == null) {
                        if (eyeTwoBreaks.length > 1)
                            this.straightThreeSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeTwoBreaks[1].timeBreak) / 8000);
                    }


                    if (eyeBreak.eyeNumber == eyeFourNumber && this.aroundBarrelThreeSplit == null) {
                        if (eyeFourBreaks.length > 1)
                            this.aroundBarrelThreeSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeFourBreaks[0].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == "1" && this.straightFourSplit == null) {
                        if (eyeFourBreaks.length > 1)
                            this.straightFourSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeFourBreaks[1].timeBreak) / 8000);
                    }
                }
                else {
                    if (eyeBreak.eyeNumber == eyeTwoNumber && this.aroundBarrelOneSplit == null) {
                        this.aroundBarrelOneSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - this.eyeBreaks.filter(x => x.eyeNumber == eyeTwoNumber)[0].timeBreak) / 8000);
                    }


                    if (eyeBreak.eyeNumber == eyeThreeNumber && this.straightTwoSplit == null) {
                        if (eyeTwoBreaks.length > 1)
                            this.straightTwoSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeTwoBreaks[1].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == eyeThreeNumber && this.aroundBarrelTwoSplit == null) {
                        if (eyeThreeBreaks.length > 1)
                            this.aroundBarrelTwoSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeThreeBreaks[0].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == eyeFourNumber && this.straightThreeSplit == null) {
                        if (eyeThreeBreaks.length > 1)
                            this.straightThreeSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeThreeBreaks[1].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == eyeFourNumber && this.aroundBarrelThreeSplit == null) {
                        if (eyeFourBreaks.length > 1)
                            this.aroundBarrelThreeSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeFourBreaks[0].timeBreak) / 8000);
                    }

                    if (eyeBreak.eyeNumber == "1" && this.straightFourSplit == null) {
                        if (eyeFourBreaks.length > 1)
                            this.straightFourSplit = this.formatTime((this.eyeBreaks[this.eyeBreaks.length - 1].timeBreak - eyeFourBreaks[1].timeBreak) / 8000);
                    }
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/lib/farmtek-reader.ts